import { DataInputItem } from "./components/DataInputRow";
import { AutomationVariableDefinition } from "./types";

export const buildCxAutomationSupportedVariables = (
  dataInputs: DataInputItem[]
): AutomationVariableDefinition[] => {
  const fromInputs = new Map<string, AutomationVariableDefinition>();

  dataInputs.forEach((input) => {
    const name = input.name.trim();
    if (!name) {
      return;
    }
    fromInputs.set(name, { id: name, label: name, type: "text" });
  });

  return [...fromInputs.values()];
};

export const mapVariablesToAutomationListItems = (
  variables: AutomationVariableDefinition[],
  dataInputs: DataInputItem[] = []
): {
  id: string;
  value: {
    label: string;
    description?: string;
    type: AutomationVariableDefinition["type"];
  };
}[] => {
  const descriptionByName = new Map<string, string>();

  dataInputs.forEach((input) => {
    const name = input.name.trim();
    const description = input.description.trim();
    if (name && description) {
      descriptionByName.set(name, description);
    }
  });

  const uniqueVariables = new Map<string, AutomationVariableDefinition>();

  variables.forEach((variable) => {
    if (!uniqueVariables.has(variable.id)) {
      uniqueVariables.set(variable.id, variable);
    }
  });

  return [...uniqueVariables.values()].map((variable) => ({
    id: variable.id,
    value: {
      label: variable.label,
      description: descriptionByName.get(variable.id),
      type: "text",
    },
  }));
};
